<script lang="ts">
  export let id: string;
  export let half: 'top' | 'bottom' | null = null;
  export let disabled = false;
  export let label: string;
  export let onPress: () => void;

  function depressButtonOnTouch(evt: Event) {
    console.log('touch start');
    evt.preventDefault();
    evt.stopPropagation();
    (evt.target as HTMLButtonElement).classList.add('active');
    onPress();
  }

  function releaseButtonOnTouchEnd(evt: Event) {
    console.log('touch end');

    evt.preventDefault();
    evt.stopPropagation();

    (evt.target as HTMLButtonElement).classList.remove('active');
  }

  function keydown(evt: KeyboardEvent) {
    if (evt.key === ' ' || evt.key === 'Enter') {
      evt.preventDefault(); // stops Space from scrolling the page
      onPress();
    }
  }
</script>

<button
  {id}
  class="circle"
  class:half={half !== null}
  class:top={half === 'top'}
  class:bottom={half === 'bottom'}
  {disabled}
  aria-disabled={disabled}
  on:touchend={releaseButtonOnTouchEnd}
  on:touchstart={depressButtonOnTouch}
  on:keydown={keydown}
  on:mousedown={depressButtonOnTouch}
  on:mouseup={releaseButtonOnTouchEnd}>{@html label}</button
>

<style>
  .circle {
    width: calc(var(--diameter) * 0.25);
    height: calc(var(--diameter) * 0.25);
    border-radius: 50%;
    text-align: center;
    font-family: 'Orelega One', serif;
    font-size: calc(var(--diameter) * 0.15);
    line-height: calc(var(--diameter) * 0.25);
    transition:
      filter 1s,
      transform 0.05s,
      text-shadow 0.1s;

    padding: 0;
    border: none;
    outline: none;
  }

  .circle:focus-visible {
    outline: auto;
  }

  .circle.half {
    height: calc(var(--diameter) * 0.125);
    font-size: calc(var(--diameter) * 0.09);
    line-height: calc(var(--diameter) * 0.125);
    border-radius: 0%;
  }
  .circle.half.bottom {
    border-bottom-left-radius: calc(var(--diameter) * 0.25);
    border-bottom-right-radius: calc(var(--diameter) * 0.25);
  }
  .circle.half.top {
    border-top-left-radius: calc(var(--diameter) * 0.25);
    border-top-right-radius: calc(var(--diameter) * 0.25);
  }
  .circle:hover:not(:disabled) {
    cursor: pointer;
    transform: scale(1.05);
    text-shadow: 0px 0px 6px white;
  }
  .circle:active:not(:disabled),
  :global(.circle.active:not(:disabled)) {
    transform: scale(1);
    color: #dddddd;
  }
  .circle:disabled {
    filter: brightness(30%);
  }

  #D {
    background: #ff5050;
    position: absolute;
    top: calc(var(--diameter) * 0.1);
    left: calc(var(--diameter) * 0.375);
  }
  #R {
    background: #ff9999;
    position: absolute;
    top: calc(var(--diameter) * 0.212);
    left: calc(var(--diameter) * 0.61);
  }
  #M {
    background: #50f050;
    position: absolute;
    top: calc(var(--diameter) * 0.467);
    left: calc(var(--diameter) * 0.665);
  }
  #F {
    background: #6060ff;
    position: absolute;
    top: calc(var(--diameter) * 0.67);
    left: calc(var(--diameter) * 0.505);
  }
  #S {
    background: #ffa23a;
    position: absolute;
    top: calc(var(--diameter) * 0.67);
    left: calc(var(--diameter) * 0.245);
  }
  #L {
    background: #ff60a8;
    position: absolute;
    top: calc(var(--diameter) * 0.467);
    left: calc(var(--diameter) * 0.082);
  }
  #T {
    background: #f0f000;
    position: absolute;
    top: calc(var(--diameter) * 0.212);
    left: calc(var(--diameter) * 0.14);
  }
  #LE {
    background: #bf5eff;
    position: absolute;
    top: calc(var(--diameter) * 0.592);
    left: calc(var(--diameter) * 0.082);
  }
  #LA {
    background: #ff60a8;
    position: absolute;
    top: calc(var(--diameter) * 0.467);
    left: calc(var(--diameter) * 0.082);
  }
  #TE {
    background: #ffd07a;
    position: absolute;
    top: calc(var(--diameter) * 0.337);
    left: calc(var(--diameter) * 0.14);
  }
  #TI {
    background: #f0f000;
    position: absolute;
    top: calc(var(--diameter) * 0.212);
    left: calc(var(--diameter) * 0.14);
  }
</style>
